const TopRightArrowIcon = () => (
  <svg width="13" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.5 0.675593V9.72538C13.5 10.0838 13.2093 10.3738 12.85 10.3738C12.4907 10.3738 12.2 10.0838 12.2 9.72538V2.24401L1.60897 12.8095C1.48262 12.9352 1.31606 13 1.1499 13C0.983746 13 0.817263 12.9367 0.690431 12.81C0.436523 12.5567 0.436523 12.1462 0.690431 11.8933L11.2896 1.31966L3.74952 1.29718C3.38876 1.29566 3.0987 1.00387 3.09992 0.647224C3.10119 0.288799 3.39193 0 3.74992 0L12.85 0.026594C13.2116 0.0287744 13.5 0.318951 13.5 0.675593Z"
      fill="#6B7280"
    />
  </svg>
);
export default TopRightArrowIcon;
